/*
quicknav
Quicknav to navigate quick to some sites

https://www.gww-netz.de/de/

Author: tobias.wolf@wagnerwagner.de
*/


(function () {
  function Quicknav(element) {
    // elements
    const bodyElement = document.querySelector('body');
    const mainNavigationElement = document.querySelector('.main-navigation');
    const itemsElement = element.querySelector('.quicknav__items');
    const itemElements = itemsElement.querySelectorAll('.quicknav__item');
    const toggleNavigationElement = element.querySelector('.toggle-navigation');

    // variables
    const items = [];
    let heightOfItemsElement;
    let heightOfMainNavigationElement;

    // functions
    function init() {
      heightOfItemsElement = itemsElement.offsetHeight;
      // 4 is margin of header
      heightOfMainNavigationElement = mainNavigationElement.offsetHeight + 4;
      itemsElement.style.transitionDuration = '0s';
      itemsElement.classList.add('is-close');
      itemsElement.offsetHeight;
      itemsElement.style.transitionDuration = null;
      for (let i = 0; i < itemElements.length; i++) {
        items.push(new QuicknavItem(itemElements[i]));
      }
    }
    function open() {
      SCROLLING.scrollTop(null, heightOfMainNavigationElement, TRANSITION_DURATION, () => {
        bodyElement.classList.add('no-scroll');
        bodyElement.style.marginTop = `${heightOfMainNavigationElement * -1}px`;
      });
      backgroundImageElement.classList.add('is-blurred');
      itemsElement.classList.remove('is-close');
      toggleNavigationElement.classList.add('is-active');
      itemsElement.style.height = `${heightOfItemsElement}px`;
      itemsElement.addEventListener('transitionend', () => {
        itemsElement.style.height = null;
      });
    }
    function close() {
      if (!itemsElement.classList.contains('is-close')) {
        closeOtherItems();
        backgroundImageElement.classList.remove('is-blurred');
        bodyElement.classList.remove('no-scroll');
        bodyElement.style.marginTop = null;
        document.documentElement.scrollTop = heightOfMainNavigationElement;
        document.body.parentNode.scrollTop = heightOfMainNavigationElement;
        document.body.scrollTop = heightOfMainNavigationElement;
        toggleNavigationElement.classList.remove('is-active');
        heightOfItemsElement = itemsElement.offsetHeight;
        itemsElement.style.height = `${heightOfItemsElement}px`;
        itemsElement.classList.add('is-close');
        itemsElement.style.height = null;
      }
    }
    function closeOtherItems(exceptItem) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item !== exceptItem) {
          item.close();
        }
      }
    }
    function handleToggleNavigationClick() {
      if (itemsElement.classList.contains('is-close')) {
        open();
      } else {
        close();
      }
    }
    function handleClick(e) {
      if (e.target.classList.contains('quicknav')) {
        close();
        closeOtherItems();
      }
    }

    // event listener
    toggleNavigationElement.addEventListener('click', handleToggleNavigationClick);
    element.addEventListener('click', handleClick, false);

    // init
    init();

    // public varibales
    this.closeOtherItems = closeOtherItems;
  }

  function QuicknavItem(element) {
    // elements
    const popupElement = element.querySelector('.quicknav__popup');
    const buttonElement = element.querySelector('.button_quicknav');

    // variables
    let heightOfPopupElement;
    const self = this;

    // functions
    function init() {
      heightOfPopupElement = popupElement.offsetHeight;
      popupElement.style.transitionDuration = '0s';
      element.classList.add('is-close');
      popupElement.hidden = true;
      popupElement.offsetHeight;
      popupElement.style.transitionDuration = null;
      updateButton();
    }
    function updateButton() {
      if (window.matchMedia('screen and (min-width: 928px)').matches) {
        buttonElement.classList.remove('button_down');
        buttonElement.classList.add('button_right');
      } else {
        buttonElement.classList.add('button_down');
        buttonElement.classList.remove('button_right');
      }
    }
    function open() {
      popupElement.hidden = false;
      popupElement.offsetHeight;
      quicknav.closeOtherItems(self);
      element.classList.remove('is-close');
      buttonElement.classList.add('is-active');
      if (window.matchMedia('screen and (min-width: 928px)').matches) {
        backgroundImageElement.classList.add('is-blurred');
      } else {
        popupElement.style.height = `${heightOfPopupElement}px`;
        popupElement.addEventListener('transitionend', () => {
          popupElement.style.height = null;
        });
        buttonElement.classList.add('button_up');
        buttonElement.classList.remove('button_down');
      }
    }
    function close() {
      if (!element.classList.contains('is-close')) {
        heightOfPopupElement = popupElement.offsetHeight;
        buttonElement.classList.remove('is-active');
        if (window.matchMedia('screen and (min-width: 928px)').matches) {
          backgroundImageElement.classList.remove('is-blurred');
        } else {
          buttonElement.classList.add('button_down');
          buttonElement.classList.remove('button_up');
          popupElement.style.height = `${heightOfPopupElement}px`;
          popupElement.offsetHeight;
          popupElement.style.height = null;
        }
        element.classList.add('is-close');
        setTimeout(() => {
          if (element.classList.contains('is-close')) {
            popupElement.hidden = true;
          }
        }, TRANSITION_DURATION * 2 + 100);
      }
    }
    function handleButtonClick() {
      if (element.classList.contains('is-close')) {
        open();
      } else {
        close();
      }
    }
    function handleResize() {
      updateButton();
    }

    // event listener
    buttonElement.addEventListener('click', handleButtonClick);
    window.addEventListener('resize', handleResize);

    // init
    init();

    // public variables
    this.close = close;
  }

  // elements
  const element = document.querySelector('.quicknav');
  let backgroundImageElement;
  let quicknav;

  // init
  if (element) {
    backgroundImageElement = element.querySelector('.quicknav__background-image');
    quicknav = new Quicknav(element);
  }
}());
